<template>
    <div class="modal-content m-selectionProducts">
        <div class="modal-contentWrap">
            <!-- Modal Header -->
            <div class="modal-header bg-1">
                <modal-close />
                <modal-back
                    v-if="modalArgs.selectionProductsParams"
                    :on-click-back="goBack"
                />
                <div class="modal-title text-center my-1">
                    <h3 class="h3 mb-1" v-text="'Ustaw kod lokalny produktu'" />
                    <p class="h5 mb-0" v-text="dictProduct.name" />
                    <span class="text-sm" v-text="dictProduct.ean" />
                </div>
            </div>

            <!-- Modal Body -->
            <page-preloader v-if="fetchLoader" />

            <div
                v-if="altEans.length > 1"
                class="d-flex gap-1 w-100 justify-content-end align-items-start pt-3 px-3"
            >
                <local-code
                    class="mb-0"
                    placeholder="Kod lokalny"
                    :product="dictProduct"
                    :text="massiveEan"
                    :disabled="saveLoader"
                    @input="massiveEan = $event"
                />

                <the-btn
                    text="Zastosuj dla wszystkich"
                    :disabled="!massiveEan || checkingEanLoader"
                    @click="onSaveAll"
                />
            </div>

            <div class="modal-body py-4 px-3">
                <div class="c-table set-alternative-eans">
                    <div class="c-thead">
                        <div class="c-td is-1">Sklep</div>
                        <div class="c-td is-2">Kod lokalny</div>
                    </div>
                    <div class="c-tbody">
                        <div
                            v-for="product in altEans"
                            class="c-row"
                            :key="product.merchant.id"
                        >
                            <div class="c-tr">
                                <div class="c-td is-1">
                                    <h6 v-text="product.merchant.name" class="mb-0" />

                                    {{ product.merchant.fullAddress }}
                                </div>

                                <div class="c-td is-2 d-flex gap-0-5">
                                    <local-code
                                        class="mb-0 w-100"
                                        :product="dictProduct"
                                        :text="product.alternative_ean"
                                        :disabled="isSaving"
                                        @input="saveAltEan(product, $event)"
                                        @keyup="checkIfEansExist"
                                    />

                                    <v-popover
                                        v-if="product.id"
                                        class="remove-popover"
                                        offset="8"
                                        :container="false"
                                    >
                                        <the-btn
                                            class="remove-local-code btn-sm btn-danger"
                                            :disabled="isSaving"
                                        >
                                            <a-icon
                                                width="16"
                                                height="16"
                                                :icon="
                                                    fetchingId === product.id
                                                        ? 'Spinner'
                                                        : 'Bin'
                                                "
                                            />
                                        </the-btn>

                                        <template slot="popover">
                                            <popover-confirm
                                                message="Usunąć?"
                                                confirmText="Potwierdź"
                                                @confirmed="removeAlternativeEan(product.id)"
                                            />
                                        </template>
                                    </v-popover>
                                </div>
                            </div>
                            <div
                                v-if="(code = existingCode(product))"
                                class="text-danger text-right px-3 pb-2"
                                style="margin-top: -0.5rem"
                            >
                                Kod został już zapisany dla produktu
                                {{ code.name }},
                                {{ code.ean }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer" style="position: sticky; bottom: 0;">
                <the-btn
                    text="Zamknij"
                    class="btn-outline-custom mr-auto"
                    @click="$store.dispatch('toggleModal', false)"
                />

                <the-btn
                    v-if="modalArgs.selectionProductsParams"
                    :disabled="
                        changedCodes.length === 0 ||
                            errors.length > 0 ||
                            saveAndBackLoader
                    "
                    @click="saveAndGoBack"
                >
                    Zapisz i uzupełnij kolejny
                    <button-spinner offset="2" :status="saveAndBackLoader ? 'loading' : 'idle'" />
                </the-btn>

                <the-btn :disabled="isSaveAndCloseBtnDisabled" @click="saveAndClose">
                    Zapisz i zamknij
                    <button-spinner offset="2" :status="saveAndCloseLoader ? 'loading' : 'idle'" />
                </the-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { wtProducts } from '@/walkthroughs/altEans'
import { wtMerchants } from '@/walkthroughs/wtData'

export default {
    name: 'ModalAlternativeEans',

    data() {
        return {
            fetchLoader: false,
            saveLoader: false,
            checkingEanLoader: false,
            saveAndCloseLoader: false,
            saveAndBackLoader: false,
            fetchingId: null,
            initialState: null,
            massiveEan: '',
            altEans: [],
            errors: [],
            lastPayload: '[]'
        }
    },

    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },

        dictProduct() {
            return this.modalArgs.dictProduct
        },

        merchants() {
            const availableMerchants = this.$store.getters.getAvailableMerchants
            const selectedMerchantIds = this.$store.getters.getAltEansFilters
                .merchant_id.value

            if (selectedMerchantIds.length) {
                return availableMerchants.filter(merchant =>
                    selectedMerchantIds.includes(merchant.id)
                )
            } else {
                return availableMerchants
            }
        },

        changedCodes() {
            if (!this.initialState) return false
            const { initialState, altEans } = this

            return altEans.filter(initEan => {
                const newEan = initialState.find(
                    newEan => newEan.merchant.id === initEan.merchant.id
                )

                return newEan.alternative_ean !== initEan.alternative_ean
            })
        },

        isSaving() {
            return (
                this.saveLoader ||
                this.saveAndCloseLoader ||
                this.saveAndBackLoader
            )
        },

        isSaveAndCloseBtnDisabled() {
            const codesNotChanged = this.changedCodes.length === 0
            const errorsExist = this.errors.length > 0

            return codesNotChanged || errorsExist || this.isSaving
        },

        isWalkthrough() {
            return this.$store.getters.getWalkthroughActive
        }
    },

    methods: {
        async fetchAltEans() {
            if (this.isWalkthrough) {
                this.massiveEan = '555'
                this.altEans = wtMerchants.map(merchant => ({
                    merchant,
                    dict_product_id: wtProducts[0].dict_product_id,
                    alternative_ean: wtProducts[0].alternative_ean,
                    id: wtProducts[0].id
                }))

                return
            }

            this.fetchLoader = true
            const res = await this.$store.dispatch('fetchAltEans', {
                params: {
                    includes: 'merchant_alternative_eans,image',
                    id: this.dictProduct.id,
                    per: 99999
                }
            })

            const product = res.data.data[0]

            this.altEans = this.merchants.map(merchant => {
                let altEan
                if (product.alternative_eans) {
                    altEan = product.alternative_eans.find(
                        altEan => altEan.merchant_id === merchant.id
                    )
                }

                return {
                    merchant,
                    dict_product_id: product.id,
                    alternative_ean: altEan ? altEan.alternative_ean : '',
                    id: altEan ? altEan.id : ''
                }
            })

            this.fetchLoader = false
            return true
        },

        async updateEans() {
            this.saveLoader = true
            const products = this.altEans
                .filter(product => product.alternative_ean)
                .map(product => ({
                    dict_product_id: this.dictProduct.id,
                    merchant_id: product.merchant.id,
                    alternative_ean: product.alternative_ean,
                    id: product.id
                }))

            const res = await this.$store.dispatch('updateAllAltEans', products)

            await this.$store.dispatch('loadAltEans')

            this.updateInitState()
            this.saveLoader = false
            return res
        },

        async saveAndClose() {
            this.saveAndCloseLoader = true
            const res = await this.updateEans()

            if (res.success.length) {
                this.updateInitState()

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zapisano'
                })

                this.$store.dispatch('toggleModal', false)
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd'
                })
            }

            this.saveAndCloseLoader = false
        },

        async saveAndGoBack() {
            this.saveAndBackLoader = true
            const res = await this.updateEans()

            if (res.success.length) {
                this.updateInitState()

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zapisano'
                })

                this.goBack()
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd'
                })
            }

            this.saveAndBackLoader = false
        },

        updateInitState() {
            this.initialState = JSON.parse(JSON.stringify(this.altEans))
        },

        goBack() {
            this.$store.dispatch('openModal', {
                component: 'MerchantEanSelectionProducts',
                args: {
                    params: this.modalArgs.selectionProductsParams
                }
            })
        },

        async checkIfEansExist() {
            // To prevent unnecessary requests, we compare the current changed codes
            // with the last checked ones. If they are the same, we skip the check.
            const currentPayload = JSON.stringify(this.changedCodes)
            if (this.lastPayload === currentPayload) return

            this.checkingEanLoader = true

            this.$store.dispatch('checkIfEansExist', this.changedCodes).then((errors) => {
                this.errors = errors
                this.lastPayload = currentPayload
            })

            this.checkingEanLoader = false
        },

        async saveAltEan(product, ean) {
            this.$set(product, 'alternative_ean', ean)
            const merchant = this.merchants.find(
                merchant => merchant.id === product.merchant.id
            )
            this.$set(merchant, 'alternative_ean', ean)
        },

        async onSaveAll() {
            for (let i = 0; i < this.altEans.length; i++) {
                this.$set(this.altEans, i, {
                    ...this.altEans[i],
                    alternative_ean: this.massiveEan
                })
            }
            this.$forceUpdate()

            await this.checkIfEansExist()
        },

        async removeAlternativeEan(eanId) {
            this.fetchingId = eanId
            const res = await this.$store.dispatch('deleteAltEan', eanId)

            if (res.status === 200) {
                this.updateInitState()

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Usunięto'
                })
            } else {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd'
                })
            }

            await this.fetchAltEans()
            await this.updateInitState()
            this.$store.dispatch('loadAltEans')
            this.fetchingId = null
        },

        existingCode(product) {
            return (this.errors || []).find(
                error =>
                    error.alternative_ean === product.alternative_ean &&
                    error.merchant_id === product.merchant.id
            )
        }
    },

    async created() {
        await this.fetchAltEans()
        this.updateInitState()
    }
}
</script>
